type Props = {
  photoUrl?: string | null
  label: string
  size?: 'xs' | 'sm' | 'default' | 'lg'
  className?: string
}

const sizeMap = { xs: 'w-4 h-4 text-[10px]', sm: 'w-6 h-6 text-xs', default: 'w-8 h-8 text-sm', lg: 'w-10 h-10 text-base' }

export function MediaAvatar({ photoUrl, label, size = 'default', className }: Props) {
  const initial = (label || '?')[0]?.toUpperCase() ?? '?'

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        className={`rounded-full object-cover shrink-0 ${sizeMap[size]} ${className ?? ''}`}
      />
    )
  }

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-muted text-muted-foreground font-medium shrink-0 ${sizeMap[size]} ${className ?? ''}`}
    >
      {initial}
    </span>
  )
}
